import React, { forwardRef, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loaderActions } from '../../../_actions/loader.actions';
import { encryptUrlDatapattern } from '../../../components/commonClass/EncFunc';
import { trackSearch } from '../../../components/commonClass/CommonFunctions';
import CustomDropDown from './CustomDropDown';
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutoComplete } from 'antd';
import { formatDateddmmyyy } from '../../../components/commonClass/CommonValidation';
import 'react-dates/initialize';
import { DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { getData } from '../../../services/ApiCallingUserServices';


const FilterFormFlight = ({ formValue }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState([]);
    const [swapping, setSwapping] = useState(false)
    const [formError, setFormError] = useState({})
    const [multicitycollection, setMultiCityCollection] = useState([])
    const [swappingIndex, setSwappingIndex] = useState(null)
    const infantsmessage = "Number of infants cannot be more than adults."
    const [form, setForm] = useState({
        FromCityCode: 'DEL',
        ToCityCode: '',
        JourneyType: 1,
        adults: 1,
        children: 0,
        infants: 0,
        Departure: null,
        Return: null,
        FlightCabinClass: 2,
        FromId: 932,
        AirportFromLocationName: 'Delhi',
        ToId: 0,
        AirportToLocationName: '',
        fromCountryId: 1,
        toCountryId: null,
    })

    const [focusedInput, setFocusedInput] = useState('startDate');
    const [calendarOpen, setCalendarOpen] = useState(false);

    const getFlightData = async () => {
        dispatch(loaderActions.start());
        await getData('/customerui/v1/getflightuiconfigurations')?.then((rep) => {
            setData(rep?.data)
            dispatch(loaderActions.end());
        })
    };

    const hendlechange = (name, val) => {
        if (name === "JourneyType") {
            setForm({ ...form, [name]: val, Return: val?.TripTypeId === 2 ? form?.Return : null })
            if (val?.TripTypeId === 3 && multicitycollection?.length === 0) {
                let collection = {
                    FromCityCode: 'DEL',
                    ToCityCode: '',
                    JourneyType: 3,
                    adults: 1,
                    children: 0,
                    infants: 0,
                    Departure: formatDate(new Date()) + 'T00:00:00',
                    Return: null,
                    FlightCabinClass: 2,
                    FromId: 932,
                    AirportFromLocationName: 'Delhi',
                    ToId: 0,
                    AirportToLocationName: '',
                    fromCountryId: 1,
                    toCountryId: null,
                }
                let collection1 = {
                    FromCityCode: '',
                    ToCityCode: '',
                    JourneyType: 3,
                    adults: 1,
                    children: 0,
                    infants: 0,
                    Departure: null,
                    Return: null,
                    FlightCabinClass: 2,
                    FromId: 0,
                    AirportFromLocationName: '',
                    ToId: 0,
                    AirportToLocationName: '',
                    fromCountryId: null,
                    toCountryId: null,
                }
                setMultiCityCollection(prev => [...prev, collection, collection1]);
            }
            else {
                setMultiCityCollection([]);
            }
        }
        else {
            setForm({ ...form, [name]: val })
        }
    }

    const decrementCount = (name, minvalue) => {
        if (name === 'adults' && form?.adults - 1 < form?.infants) {
            setForm({ ...form, [name]: form?.[name] - 1, Infant: form?.[name] - 1 })
        }
        else if (minvalue <= form?.[name] - 1) {
            setForm({ ...form, [name]: form?.[name] - 1 })
        }
    }

    const incrementCount = (name, maxvalue) => {
        if (form?.[name] + 1 <= maxvalue) {
            setForm({ ...form, [name]: form?.[name] + 1 })
        }
    }

    const handleChange = (name, e, index) => {
        setFormError({});
        const value = e;
        if (form?.JourneyType?.TripTypeId < 3) {
            if (value) {
                if (name === 'AirportFromLocationName') {
                    setForm({ ...form, [name]: value, FromId: 0 })
                } else if (name === 'AirportToLocationName') {
                    setForm({ ...form, [name]: value, ToId: 0 })
                }
            }
            else {
                if (name === 'AirportFromLocationName') {
                    setForm({ ...form, [name]: value, FromId: 0 })
                }
                if (name === 'AirportToLocationName') {
                    setForm({ ...form, [name]: value, ToId: 0 })
                }
            }
        }
        else if (form?.JourneyType?.TripTypeId === 3) {
            if (value) {
                setMultiCityCollection(multicitycollection?.map((el, childindex) => {
                    if (index === childindex) {
                        if (name === 'AirportFromLocationName') {
                            el.AirportFromLocationName = value
                        }
                        else if (name === 'AirportToLocationName') {
                            el.AirportToLocationName = value
                        }
                    }
                    return el
                }))
            }
            else {
                setMultiCityCollection(multicitycollection?.map((el, childindex) => {
                    if (index === childindex) {
                        if (name === 'AirportFromLocationName') {
                            el.AirportFromLocationName = value
                            el.FromId = 0
                        }
                        else if (name === 'AirportToLocationName') {
                            el.AirportToLocationName = value
                            el.ToId = 0
                        }
                    }
                    return el
                }))
            }
        }
    }

    const hendledate = (name, e, index) => {
        setFormError({});
        let val = e
        if (name === 'Return') {
            setForm({ ...form, [name]: (val === "" || val === null) ? null : val + 'T00:00:00' })
        }
        else {
            if (form?.JourneyType?.TripTypeId === 2 && e !== null) {
                document?.getElementById('Returnid')?.click()
            }
            if (form?.JourneyType?.TripTypeId < 3) {
                setForm({ ...form, [name]: (val === "" || val === null) ? null : val + 'T00:00:00' })
            }
            else {
                setMultiCityCollection(multicitycollection?.map((el, childindex) => {
                    if (index === childindex) {
                        el.Departure = (val === "" || val === null) ? null : val + 'T00:00:00'
                    }
                    if (index < childindex) {
                        el.Departure = null
                    }
                    return el
                }))
            }
        }
    }

    const handleSuggestionClick = (name, suggestion, id, CityCode, CountryId, index) => {
        setFormError({});
        if (name === 'AirportFromLocationName') {
            if (form?.JourneyType?.TripTypeId < 3) {
                setForm({ ...form, [name]: suggestion, FromId: id, FromCityCode: CityCode, fromCountryId: CountryId })
            }
            else {
                setMultiCityCollection(multicitycollection?.map((el, childindex) => {
                    if (index === childindex) {
                        el.AirportFromLocationName = suggestion
                        el.FromId = id
                        el.FromCityCode = CityCode
                        el.fromCountryId = CountryId
                    }
                    return el
                }))
            }
        }
        else {
            if (form?.JourneyType?.TripTypeId < 3) {
                setForm({ ...form, [name]: suggestion, ToId: id, ToCityCode: CityCode, toCountryId: CountryId })
            }
            else {
                setMultiCityCollection(multicitycollection?.map((el, childindex) => {
                    if (index === childindex) {
                        el.AirportToLocationName = suggestion
                        el.ToId = id
                        el.ToCityCode = CityCode
                        el.toCountryId = CountryId
                    }
                    if (name === "AirportToLocationName" && childindex === index + 1) {
                        el.AirportFromLocationName = suggestion
                        el.FromId = id
                        el.FromCityCode = CityCode
                        el.fromCountryId = CountryId
                        if (id === el.ToId) {
                            el.AirportToLocationName = ''
                            el.ToId = 0
                            el.ToCityCode = ''
                            el.toCountryId = 0
                        }
                    }
                    return el
                }))
            }
        }
    }

    const Swapping = (index) => {
        setSwapping(true);
        if (form.JourneyType?.TripTypeId < 3) {
            setForm({
                ...form,
                FromId: form.ToId,
                ToId: form?.FromId,
                AirportFromLocationName: form?.AirportToLocationName,
                AirportToLocationName: form?.AirportFromLocationName,
                FromCityCode: form?.ToCityCode,
                ToCityCode: form?.FromCityCode,
                fromCountryId: form?.toCountryId,
                toCountryId: form?.fromCountryId
            })
        }
        else {
            setSwappingIndex(index)
            let val = multicitycollection?.[index]
            setMultiCityCollection(multicitycollection?.map((el, childindex) => {
                if (index === childindex) {
                    return {
                        ...el,
                        FromId: val?.ToId,
                        ToId: val?.FromId,
                        AirportFromLocationName: val?.AirportToLocationName,
                        AirportToLocationName: val?.AirportFromLocationName,
                        FromCityCode: val?.ToCityCode,
                        ToCityCode: val?.FromCityCode,
                        fromCountryId: val?.toCountryId,
                        toCountryId: val?.fromCountryId,
                    };
                }
                return el;
            }));
        }

    }

    //#region handle departure and return dates functions of return flight
    const hendleReturnDate = (startDate, endDate) => {
        setForm({ ...form, Departure: startDate === "" ? null : startDate, Return: endDate === "" ? null : endDate })
        endDate && setCalendarOpen(false)
    }

    const handleOutsideClick = (e) => {
        const targetIds = ["Departure", "Return", "departureIconCalander", "returnIconCalander"]
        if (!targetIds?.includes(e?.target?.id)) {
            setCalendarOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);
    //#endregion

    const valid = () => {
        let errorMessages = {};
        let isError = true
        if (form?.adults < form?.infants) {
            errorMessages['infants'] = 'Number of infants cannot be more than adults.'
            isError = false
        }
        if (form?.FromId === 0) {
            errorMessages['AirportFromLocationName'] = 'Please select from destination.'
            isError = false
        }
        if (form?.ToId === 0) {
            errorMessages['AirportToLocationName'] = 'Please select To destination.'
            isError = false
        }
        if (form?.JourneyType?.TripTypeId === 2 && form?.Return === null) {
            errorMessages['Return'] = 'Please select your return date.'
            isError = false
        }
        if (form?.Departure === null) {
            errorMessages['Departure'] = 'Please select your departure date.'
            isError = false
        }
        setFormError(errorMessages);
        return isError;
    }

    const createSearchUrl = (data, multi = false) => {
        // const urlParams = new URLSearchParams(searchParams);

        //for multiple journetype
        const urlParams = new URLSearchParams();
        if (data?.JourneyType?.TripTypeId === 3) {
            multi?.map((el, index) => {
                urlParams.set(`tcc${index + 1}`, el?.ToCityCode);
                urlParams.set(`destination${index + 1}`, el?.AirportToLocationName);
                urlParams.set(`departure${index + 1}`, el?.AirportFromLocationName);
                urlParams.set(`fcc${index + 1}`, el?.FromCityCode);
                if (el?.Departure) {
                    let depdate = el?.Departure?.split("T")[0]
                    urlParams.set(`DepartureDate${index + 1}`, depdate);
                }
            })
        }

        Object.entries(data).forEach((val) => {
            if (val[0] === "JourneyType" && val[1]?.TripTypeId !== 2 || !val[0]) {
                urlParams?.delete("ReturnDate");
            }

            if (searchParams.get(val[0])) {
                urlParams?.delete(val[0]);
            }

            let keys = [
                "JourneyType", "FlightCabinClass", "adults", "children",
                "infants", "Departure", "Return", "FromCityCode", "ToCityCode"
            ];

            if (keys.includes(val[0])) {
                if (val[0] === "Departure" || val[0] === "Return") {
                    val[1] = val[1]?.split("T")[0];
                }

                if (val[0] === 'ToCityCode' && data?.JourneyType?.TripTypeId < 3) {
                    val[1] && urlParams.set('tcc', val[1]);
                }
                else if (val[0] === 'FromCityCode' && data?.JourneyType?.TripTypeId < 3) {
                    val[1] && urlParams.set('destination', data?.AirportToLocationName);
                    val[1] && urlParams.set('departure', data?.AirportFromLocationName);
                    val[1] && urlParams.set('fcc', val[1]);
                }
                else if (val[0] === 'FlightCabinClass') {
                    val[1] && urlParams.set('class', val[1]?.Name);
                }
                else if (val[0] === 'JourneyType') {
                    val[1] && urlParams.set('tripType', val[1]?.TripName);
                }
                else if ((val[0] === "Departure" || val[0] === "Return") && data?.JourneyType?.TripTypeId < 3) {
                    val[1] = val[1]?.split("T")[0];
                    val[1] && urlParams.set(val[0] + 'Date', val[1]);
                }
                else {
                    if (data?.JourneyType?.TripTypeId !== 3 && (val[0] === "Departure" || val[0] === "Return" || val[0] === "adults" || val[0] === "children" || val[0] === "infants")) {
                        val[1] && urlParams.set(val[0], val[1]);
                    }
                    else if (data?.JourneyType?.TripTypeId === 3 && (val[0] === "adults" || val[0] === "children" || val[0] === "infants")) {
                        val[1] && urlParams.set(val[0], val[1]);
                    }
                }
            }
        })
        urlParams.set('isExplore', true)
        return urlParams
        // setSearchParams(urlParams)
    }

    const OnExplore = () => {
        errorclear();
        if (form?.JourneyType?.TripTypeId < 3) {
            sessionStorage?.setItem('isinternational', form?.toCountryId === form?.fromCountryId ? false : true);
            if (valid()) {
                localStorage.setItem('fltmax', encryptUrlDatapattern(0));
                localStorage.setItem('fltmin', encryptUrlDatapattern(0));
                const urlPartg = `/flights/search`
                const newSearch = `?${createSearchUrl(form)?.toString()}`;
                navigate({ pathname: urlPartg, search: newSearch });
                trackSearch()
            }
        }
        if (form?.JourneyType?.TripTypeId === 3) {
            let isinternationalcheck = multicitycollection?.filter(el => (el.toCountryId !== el.fromCountryId))
            sessionStorage?.setItem('isinternational', isinternationalcheck?.length > 0);
            if (validmulti()) {
                localStorage.setItem('fltmax', encryptUrlDatapattern(0));
                localStorage.setItem('fltmin', encryptUrlDatapattern(0));
                const urlPartg = `/flights/search`
                const newSearch = `?${createSearchUrl(form, multicitycollection)?.toString()}`;
                navigate({ pathname: urlPartg, search: newSearch });
                trackSearch()
            }
        }
    }

    const errorclear = () => {
        if (formError) {
            setTimeout(() => {
                setFormError({})
            }, 5000);
        }
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return date === null ? null : [year, month, day].join('-');
    }
    const convertFilterObject = (filterData) => {
        let obj = {};
        Object.entries(filterData).forEach(([key, value]) => {
            obj[key] = value
        })
        return obj;
    }

    const transformMultiCityData = (input) => {
        const segments = [];
        const numberOfLegs = Object?.keys(input)?.filter(key => key?.startsWith('fcc'))?.length;
        for (let i = 1; i <= numberOfLegs; i++) {
            const fcc = input[`fcc${i}`]; // From city code
            const tcc = input[`tcc${i}`]; // To city code
            const departureCity = input[`departure${i}`];
            const destinationCity = input[`destination${i}`];
            const departureDate = input[`DepartureDate${i}`];
            const segment = {
                FromCityCode: fcc || '',
                ToCityCode: tcc || '',
                JourneyType: 3, // Multi Stop
                adults: input?.adults || 1,
                children: input?.children || 0,
                infants: input?.children || 0,
                Departure: departureDate + 'T00:00:00' || null,
                Return: null,
                FlightCabinClass: input?.class || 2,
                FromId: data?.cityList?.find(el => el.CityCode === fcc)?.AirportLocationId,
                AirportFromLocationName: departureCity || '',
                ToId: data?.cityList?.find(el => el.CityCode === tcc)?.AirportLocationId,
                AirportToLocationName: destinationCity || '',
                fromCountryId: data?.cityList?.find(el => el.CityCode === fcc)?.CountryId,
                toCountryId: data?.cityList?.find(el => el.CityCode === tcc)?.CountryId,
            };
            segments.push(segment);
        }

        return segments;
    }

    useMemo(() => {
        const filterFromUrl = {};
        if (searchParams.size > 0 && data?.tripType?.length > 0) {
            const queryObject = Object?.fromEntries(searchParams?.entries());

            Object?.entries(queryObject)?.forEach(([key, value]) => {
                if (
                    key === 'JourneyType' || key === 'FlightCabinClass' || key === 'adults' ||
                    key === "children" || key === "infants"
                ) {
                    filterFromUrl[key] = Number(value);
                } else {
                    filterFromUrl[key] = value ? value : [];
                }
            });

            const getURLData = convertFilterObject(filterFromUrl);
            const getURLCityCodeDetails = data?.cityList.reduce((acc, city) => {
                if (city.CityCode === getURLData?.fcc && city?.City === getURLData?.departure) {
                    acc.FromCode = city;
                } else if (city.CityCode === getURLData?.tcc && city?.City === getURLData?.destination) {
                    acc.ToCode = city;
                }
                return acc;
            }, { FromCode: null, ToCode: null });

            const getJornyType = getURLData?.tripType ? data?.tripType?.find((val) => val?.TripName?.toLowerCase() === getURLData?.tripType?.toLowerCase()) : data?.tripType?.[0];

            if (getURLData?.tripType !== "Multi Stop") {
                setForm((prev) => ({
                    ...prev,
                    JourneyType: getJornyType,
                    FlightCabinClass: getURLData?.class ? data?.travelClass?.find((val) => val?.Name?.toLowerCase() === getURLData?.class?.toLowerCase()) : data?.travelClass?.[0],

                    adults: getURLData?.adults ? getURLData?.adults : 1,
                    children: getURLData?.children ? getURLData?.children : 0,
                    infants: getURLData?.infants ? getURLData?.infants : 0,

                    FromId: getURLCityCodeDetails?.FromCode?.AirportLocationId ? getURLCityCodeDetails?.FromCode?.AirportLocationId : 932,
                    AirportFromLocationName: getURLCityCodeDetails?.FromCode?.City ? getURLCityCodeDetails?.FromCode?.City : 'Delhi',
                    FromCityCode: getURLCityCodeDetails?.FromCode?.CityCode ? getURLCityCodeDetails?.FromCode?.CityCode : 'DEL',
                    fromCountryId: getURLCityCodeDetails?.FromCode?.CountryId ? getURLCityCodeDetails?.FromCode?.CountryId : null,

                    ToId: getURLCityCodeDetails?.ToCode?.AirportLocationId ? getURLCityCodeDetails?.ToCode?.AirportLocationId : 0,
                    AirportToLocationName: getURLCityCodeDetails?.ToCode?.City ? getURLCityCodeDetails?.ToCode?.City : '',
                    ToCityCode: getURLCityCodeDetails?.ToCode?.CityCode ? getURLCityCodeDetails?.ToCode?.CityCode : '',
                    toCountryId: getURLCityCodeDetails?.ToCode?.CountryId ? getURLCityCodeDetails?.ToCode?.CountryId : null,

                    Departure: getURLData?.DepartureDate ? getURLData?.DepartureDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                    Return: getJornyType?.TripTypeId === 2 ? getURLData?.DepartureDate ? getURLData?.ReturnDate + 'T00:00:00'
                        : formatDate(new Date()) + 'T00:00:00' : null,
                }));
            }
            else {
                setForm((prev) => ({
                    ...prev,
                    JourneyType: getJornyType,
                    FlightCabinClass: getURLData?.class ? data?.travelClass?.find((val) => val?.Name?.toLowerCase() === getURLData?.class?.toLowerCase()) : data?.travelClass?.[0],

                    adults: getURLData?.adults ? getURLData?.adults : 1,
                    children: getURLData?.children ? getURLData?.children : 0,
                    infants: getURLData?.infants ? getURLData?.infants : 0,
                }));
                setMultiCityCollection(transformMultiCityData(getURLData))
            }
        } else {
            setForm({
                ...form,
                JourneyType: data?.tripType?.[0],
                FlightCabinClass: data?.travelClass?.[1],
            })
        }
    }, [formValue, data])

    const validmulti = () => {
        let errorMessages = {};
        let isError = true
        if (form?.adults < form?.infants) {
            errorMessages['infants'] = 'Number of infants cannot be more than adults.'
            isError = false
        }
        multicitycollection?.map((el, index) => {
            if (el?.FromId === 0) {
                errorMessages[`AirportFromLocationName${index}`] = 'Please select from destination.'
                isError = false
            }
            if (el?.ToId === 0) {
                errorMessages[`AirportToLocationName${index}`] = 'Please select To destination.'
                isError = false
            }
            if (el?.ToId === el?.FromId) {
                errorMessages[`AirportToLocationName${index}`] = 'Please select a different destination.'
                isError = false
            }
            if (el?.Departure === null) {
                errorMessages[`Departure${index}`] = 'Please select your departure date.'
                isError = false
            }
        })
        setFormError(errorMessages);
        return isError;
    }

    const AddCity = () => {
        setFormError({});
        if (validmulti()) {
            if (multicitycollection?.length > 0) {
                let coll = multicitycollection?.[multicitycollection?.length - 1]
                let collection = {
                    FromCityCode: coll?.ToCityCode,
                    ToCityCode: '',
                    JourneyType: form.JourneyType?.TripTypeId,
                    adults: form?.adults,
                    children: form?.children,
                    infants: form?.infants,
                    Departure: null,
                    Return: null,
                    FlightCabinClass: form?.FlightCabinClass?.BookingClassId,
                    FromId: coll?.ToId,
                    AirportFromLocationName: coll?.AirportToLocationName,
                    ToId: 0,
                    AirportToLocationName: '',
                    fromCountryId: coll?.toCountryId,
                    toCountryId: null,
                }
                setMultiCityCollection(prev => [...prev, collection]);
            }
        }
    }
    const removecity = (indexToRemove) => {
        setFormError({});
        setMultiCityCollection(prev =>
            prev.filter((_, index) => index !== indexToRemove)
        );
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return date === null ? null : [year, month, day].join('-');
    }

    useEffect(() => {
        if (swapping) {
            setTimeout(() => {
                setSwapping(false)
            }, 300);
        }
    }, [swapping])

    useEffect(() => {
        setForm({ ...form, Departure: (formatDate(new Date()) + 'T00:00:00'), Return: form?.JourneyType === 2 ? (formatDate(new Date()) + 'T00:00:00') : null })
        getFlightData()
    }, [])

    const CustomInput = forwardRef(({ value, onClick, disabled, datetype }, ref) => (
        <div className="form-floating w-100 position-relative" onClick={onClick} ref={ref}>
            <input
                id={datetype === 'Return' ? 'Returnid' : 'Departureid'}
                type="text"
                className="form-control bg-body"
                value={value}
                readOnly
                disabled={disabled}
                placeholder="Select end date"
            />
            <label htmlFor="to">{datetype}</label>
            <span className="position-absolute return_flight_calendar">
                <i className="fa fa-calendar" aria-hidden="true"></i>
            </span>
        </div>
    ));

    return (
        <form>
            <div className="topFilter">
                <CustomDropDown
                    title={data?.tripType?.find(el => el.TripTypeId === form?.JourneyType?.TripTypeId)?.TripName}
                    id={'Return-id'}
                    className={'bookingType'}
                >
                    {data?.tripType?.length > 0 ? data?.tripType?.map((option, index) => (
                        <li key={index}>
                            <a>
                                <div className="form-check">
                                    <input className="form-check-input cursor_pointer"
                                        type="radio"
                                        checked={form?.JourneyType?.TripTypeId === option?.TripTypeId}
                                        onChange={() => hendlechange('JourneyType', option)}
                                        name="JourneyType"
                                        id={`bookingType +${option?.TripTypeId}`}
                                        value={option?.TripTypeId} />
                                    <label className="form-check-label w-full" htmlFor={`bookingType +${option?.TripTypeId}`}>
                                        {option?.TripName}
                                    </label>
                                </div>
                            </a>
                        </li>
                    )) : (<li key={'No Option'}>
                        No Option
                    </li>)}
                </CustomDropDown>

                <CustomDropDown
                    title={data?.travelClass?.find(el => el.BookingClassId === form?.FlightCabinClass?.BookingClassId)?.Name}
                    id={'Economy-id'}
                    className={'travelClass'}
                >
                    {data?.travelClass?.length > 0 ? data?.travelClass?.map((option, index) => (
                        <li key={index}>
                            <a>
                                <div className="form-check">
                                    <input className="form-check-input cursor_pointer"
                                        type="radio"
                                        checked={form?.FlightCabinClass?.BookingClassId === option?.BookingClassId}
                                        onChange={() => hendlechange('FlightCabinClass', option)}
                                        name="FlightCabinClass"
                                        id={`travelClass +${option?.BookingClassId}`}
                                        value={option?.BookingClassId} />
                                    <label className="form-check-label w-full" htmlFor={`travelClass +${option?.BookingClassId}`}>
                                        {option?.Name}
                                    </label>
                                </div>
                            </a>
                        </li>
                    )) : (
                        <li key={'No Option'}>
                            No Option
                        </li>
                    )}
                </CustomDropDown>

                <CustomDropDown
                    title={
                        <>
                            <i className="fa-solid fa-user-group me-1"></i>
                            <span className='me-1'>{form?.adults + form?.children + form?.infants}</span>
                            Passenger
                            {formError?.infants && <small className="text-danger from_flightinfant_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.infants}</small>}
                        </>
                    }
                    id={'Passenger-id'}
                    className={'passenger'}
                >
                    <div className="passengersRow">
                        <div className='w-100'>
                            <p className='float-start'>
                                <i className="fa-solid fa-user me-1"></i>Adults<span>Over 11</span>
                            </p>
                            <p className='float-end'>
                                <ul className="d-flex align-items-center p-0 m-0">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => decrementCount('adults', 1)}
                                            className="btn btn-outline-primary enq count_btn_search m-0"
                                            disabled={form?.adults === 1 ? true : false}
                                        >
                                            <i className="fa-solid fa-minus" />
                                        </button>
                                    </li>
                                    <li className="mx-2 fs-6"><small className='my-0'>{form?.adults}</small></li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => incrementCount('adults', 9)}
                                            className="btn btn-outline-primary enq count_btn_search m-0"
                                            disabled={form?.adults >= 9 ? true : false || (form?.adults + form?.children + form?.infants) >= 9}
                                        >
                                            <i className="fa-solid fa-plus" />
                                        </button>
                                    </li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <div className="passengersRow">
                        <div className='w-100'>
                            <p className='float-start'>
                                <i className="fa-solid fa-children me-1"></i>Children<span>2 - 11</span>
                            </p>
                            <p className='float-end'>
                                <ul className="d-flex align-items-center p-0 m-0">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => decrementCount('children', 0)}
                                            className="btn btn-outline-primary enq count_btn_search m-0"
                                            disabled={form?.children <= 0 ? true : false}
                                        >
                                            <i className="fa-solid fa-minus" />
                                        </button>
                                    </li>
                                    <li className="mx-2 fs-6"><small className='my-0'>{form?.children}</small></li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => incrementCount('children', 8)}
                                            className="btn btn-outline-primary enq count_btn_search m-0"
                                            disabled={form?.children >= 8 ? true : false || (form?.adults + form?.children + form?.infants) >= 9}
                                        >
                                            <i className="fa-solid fa-plus" />
                                        </button>
                                    </li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <div className="passengersRow">
                        <div className='w-100'>
                            <p className='float-start'>
                                <i className="fa-solid fa-baby me-1"></i>Infants<span>Under 2</span>
                            </p>
                            <p className='float-end'>
                                <ul className="d-flex align-items-center p-0 m-0">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => decrementCount('infants', 0)}
                                            className="btn btn-outline-primary enq count_btn_search m-0"
                                            disabled={form?.infants <= 0 ? true : false}
                                        >
                                            <i className="fa-solid fa-minus" />
                                        </button>
                                    </li>
                                    <li className="mx-2 fs-6"><small className='my-0'>{form?.infants}</small></li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => incrementCount('infants', form?.adults)}
                                            className="btn btn-outline-primary enq count_btn_search m-0"
                                            disabled={form?.infants >= form?.adults ? true : false || (form?.adults + form?.children + form?.infants) >= 9}
                                        >
                                            <i className="fa-solid fa-plus" />
                                        </button>
                                    </li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <small className={`text-danger infantsmessage d-flex justify-content-center ${form?.adults < form?.infants ? 'visible' : 'invisible'}`}>{infantsmessage}</small>
                </CustomDropDown>

                {/* <CustomDropDown
                    title={<><i className="fa-solid fa-suitcase"></i><span className='ms-1'>0</span> | <i className="fa-solid fa-suitcase-rolling"></i>
                        <span className='ms-1'>0</span> </>}
                    id={'Passenger-id'}
                    className={'luggage'}
                >
                    <div className="passengersRow">
                        <p><i className="fa-solid fa-suitcase"></i> Cabin baggage </p>
                        <div className="counter">0</div>
                    </div>
                    <div className="passengersRow">
                        <p><i className="fa-solid fa-suitcase-rolling"></i> Checked baggage </p>
                        <div className="counter">0</div>
                    </div>
                </CustomDropDown> */}

            </div>
            {form?.JourneyType?.TripTypeId < 3 && <div className='mainFilter defaultFirstMulticity  row g-2'>
                <div className='col-xl-3 col-lg-6 col-md-6 pr newautocomplete'>
                    <AutoComplete
                        options={data?.cityList?.filter(suggestion =>
                            (
                                suggestion?.City?.toLowerCase()?.includes(form?.AirportFromLocationName?.toLowerCase()) ||
                                suggestion?.AirportCode?.toLowerCase()?.includes(form?.AirportFromLocationName?.toLowerCase()) ||
                                suggestion?.AirportName?.toLowerCase()?.includes(form?.AirportFromLocationName?.toLowerCase())
                            )
                            && (form?.ToId > 0 ? suggestion?.AirportLocationId !== form?.ToId : true)
                        )?.map((suggestion, index) => ({
                            key: index,
                            label: (
                                <div key={index} className='border-0 text-start'>
                                    <span>{suggestion?.City}</span>
                                    <br />
                                    <small className='text-muted text-wrap'>{suggestion?.AirportName} {`(${suggestion?.AirportCode})`}</small>
                                </div>
                            ),
                            value: suggestion?.AirportName,
                            AirportCode: suggestion?.AirportCode,
                            City: suggestion?.City,
                            CityCode: suggestion?.CityCode,
                            CountryId: suggestion?.CountryId,
                            AirportLocationId: suggestion?.AirportLocationId
                        }))}
                        onSelect={(value, option) => {
                            handleSuggestionClick('AirportFromLocationName',
                                option?.City,
                                option.AirportLocationId,
                                option?.CityCode,
                                option?.CountryId,
                            )
                        }}
                        value={form?.AirportFromLocationName || ''}
                        onChange={(e) => handleChange('AirportFromLocationName', e)}
                        autoComplete="off"
                        variant="borderless"
                        className='w-100 h-auto'
                        rootClassName='custom-autocomplete-dropdown'
                    >
                        <div className="form-floating">
                            <input type="text"
                                className="form-control"
                                id="from"
                                placeholder="From"
                                autoComplete='off'
                                name='AirportFromLocationName'
                                value={form?.AirportFromLocationName}
                            />
                            <label htmlFor="from">From</label>
                            {formError?.AirportFromLocationName && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.AirportFromLocationName}</small>}
                        </div>
                    </AutoComplete>
                    <button className="destinationSwipIcon" type='button' onClick={Swapping} disabled={form?.FromId === 0 && form?.ToId === 0}>
                        <i className={`fa-solid fa-arrow-right-arrow-left ${swapping ? 'rotate_180' : ''}`}></i>
                    </button>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 newautocomplete">
                    <AutoComplete
                        options={data?.cityList?.filter(suggestion =>
                            (
                                suggestion?.City?.toLowerCase()?.includes(form?.AirportToLocationName?.toLowerCase()) ||
                                suggestion?.AirportCode?.toLowerCase()?.includes(form?.AirportToLocationName?.toLowerCase()) ||
                                suggestion?.AirportName?.toLowerCase()?.includes(form?.AirportToLocationName?.toLowerCase())
                            )
                            && (form?.FromId > 0 ? suggestion?.AirportLocationId !== form?.FromId : true))?.map((suggestion, index) => ({
                                key: index,
                                label: (
                                    <div key={index} className='border-0 text-start'>
                                        <span>{suggestion?.City}</span>
                                        <br />
                                        <small className='text-muted text-wrap'>{suggestion?.AirportName} {`(${suggestion?.AirportCode})`}</small>
                                    </div>
                                ),
                                value: suggestion?.AirportName,
                                AirportCode: suggestion?.AirportCode,
                                City: suggestion?.City,
                                CityCode: suggestion?.CityCode,
                                CountryId: suggestion?.CountryId,
                                AirportLocationId: suggestion?.AirportLocationId
                            }))}
                        onSelect={(value, option) => {
                            handleSuggestionClick('AirportToLocationName',
                                option?.City,
                                option.AirportLocationId,
                                option?.CityCode,
                                option?.CountryId,
                            )
                        }}
                        value={form?.AirportToLocationName || ''}
                        onChange={(e) => handleChange('AirportToLocationName', e)}
                        autoComplete="off"
                        variant="borderless"
                        className='w-100 h-auto'
                        rootClassName='custom-autocomplete-dropdown'
                    >
                        <div className="form-floating">
                            <input type="text"
                                className="form-control"
                                id="to"
                                placeholder="To"
                                autoComplete='off'
                                name='AirportToLocationName'
                                value={form?.AirportToLocationName}
                            />
                            <label htmlFor="to">To</label>
                            {formError?.AirportToLocationName && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.AirportToLocationName}</small>}
                        </div>
                    </AutoComplete>
                </div>
                {
                    form?.JourneyType?.TripTypeId === 2 ?
                        <>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                <div className="form-floating position-relative">
                                    <input type="text"
                                        className="form-control cursor-pointer"
                                        id="Departure"
                                        onClick={() => setCalendarOpen(true)}
                                        name='Departure'
                                        value={form?.Departure ? formatDateddmmyyy(form?.Departure, '-') : ''}
                                        onFocus={() => setFocusedInput('startDate')}
                                        readOnly
                                        placeholder="Departure" />
                                    <label htmlFor="Departure">Departure </label>
                                    <span className="position-absolute return_flight_calendar cursor-pointer">
                                        <i id='departureIconCalander' onClick={() => setCalendarOpen(true)} className="fa fa-calendar" aria-hidden="true"></i>
                                    </span>
                                    {formError?.Departure && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.Departure}</small>}
                                </div>

                                {/* Hidden calendar popup */}
                                {calendarOpen && (
                                    <div className={`${window?.innerWidth < 991 ? 'reactdates_cal' : ''}`} style={{ position: 'absolute', zIndex: 999 }}>
                                        <DayPickerRangeController
                                            startDate={form?.Departure ? moment(form?.Departure) : null}
                                            endDate={form?.Return ? moment(form?.Return) : null}
                                            onDatesChange={({ startDate, endDate }) => {
                                                hendleReturnDate(
                                                    startDate ? startDate.format('YYYY-MM-DD') : null,
                                                    endDate ? endDate.format('YYYY-MM-DD') : null
                                                );
                                            }}
                                            focusedInput={focusedInput}
                                            onFocusChange={(input) => setFocusedInput(input || 'startDate')}
                                            numberOfMonths={window?.innerWidth < 768 ? 1 : 2}
                                            withPortal={window?.innerWidth < 1001 ? true : false}
                                            hideKeyboardShortcutsPanel={true}
                                            showClearDates={true}
                                            isOutsideRange={day => day.isBefore(moment().startOf('day'))}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                <div className="form-floating position-relative"
                                    onClick={() => setCalendarOpen(true)}>
                                    <input type="text"
                                        className="form-control cursor-pointer"
                                        id="Return"
                                        name='Return'
                                        value={form?.Return ? formatDateddmmyyy(form?.Return, '-') : ''}
                                        onFocus={() => setFocusedInput('endDate')}
                                        readOnly
                                        placeholder="Return" />
                                    <label htmlFor="Return">Return</label>
                                    <span className="position-absolute return_flight_calendar cursor-pointer">
                                        <i id='returnIconCalander' onClick={() => setCalendarOpen(true)} className="fa fa-calendar" aria-hidden="true"></i>
                                    </span>
                                    {formError?.Return && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.Return}</small>}
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="col-xl-3 col-lg-6 col-md-6">
                                <ReactDatePicker
                                    className='form-control'
                                    selected={form?.Departure ? new Date(form?.Departure) : null}
                                    onChange={(e) => hendledate('Departure', formatDate(e))}
                                    selectsStart
                                    placeholder='Departure'
                                    dateFormat="dd-MM-yyyy"
                                    startDate={form?.Departure ? new Date(form?.Departure) : null}
                                    endDate={form?.Return ? new Date(form?.Return) : null}
                                    minDate={new Date()}
                                    isClearable
                                    maxDate={form?.Return ? new Date(form?.Return) : null}
                                    customInput={<CustomInput datetype='Departure' />}
                                />
                                {formError?.Departure && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.Departure}</small>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6">
                                <ReactDatePicker
                                    className='form-control'
                                    selected={form?.Return ? new Date(form?.Return) : null}
                                    onChange={(e) => hendledate('Return', formatDate(e))}
                                    selectsEnd
                                    placeholder='Return'
                                    dateFormat="dd-MM-yyyy"
                                    disabled={form?.JourneyType?.TripTypeId === 2 ? false : true}
                                    startDate={form?.Departure ? new Date(form?.Departure) : null}
                                    isClearable={form?.Return ? true : false}
                                    minDate={form?.Departure ? new Date(form?.Departure) : new Date()}
                                    customInput={<CustomInput datetype='Return' />}
                                />
                                {formError?.Return && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.Return}</small>}
                            </div>
                        </>
                }
                <button type="button" className="btn searchBtn" onClick={() => OnExplore()}>Explore</button>
            </div>
            }
            {
                form?.JourneyType?.TripTypeId === 3 &&
                multicitycollection?.map((el, index) => (
                    index === 0 ? (
                        <div index={index} className={`mainFilter ${form?.JourneyType?.TripTypeId === 3 ? multicitycollection?.length > 1 ? 'defaultFirstMulticity' : 'modifyMultiFil' : ''} row g-2`}>
                            <div className={`${form?.JourneyType?.TripTypeId === 3 ? 'col-xl-4 col-lg-4' : 'col-xl-3 col-lg-6'} col-md-6 pr newautocomplete`}>
                                <AutoComplete
                                    options={data?.cityList?.filter(suggestion =>
                                        (
                                            suggestion?.City?.toLowerCase()?.includes(el?.AirportFromLocationName?.toLowerCase()) ||
                                            suggestion?.AirportCode?.toLowerCase()?.includes(el?.AirportFromLocationName?.toLowerCase()) ||
                                            suggestion?.AirportName?.toLowerCase()?.includes(el?.AirportFromLocationName?.toLowerCase())
                                        )
                                        && (multicitycollection?.[index]?.ToId > 0 ? suggestion?.AirportLocationId !== multicitycollection?.[index]?.ToId : true)
                                    )?.map((suggestion, sugIndex) => ({
                                        key: sugIndex,
                                        label: (
                                            <div key={index} className='border-0 text-start'>
                                                <span>{suggestion?.City}</span>
                                                <br />
                                                <small className='text-muted text-wrap'>{suggestion?.AirportName} {`(${suggestion?.AirportCode})`}</small>
                                            </div>
                                        ),
                                        value: suggestion?.AirportName,
                                        AirportCode: suggestion?.AirportCode,
                                        City: suggestion?.City,
                                        CityCode: suggestion?.CityCode,
                                        CountryId: suggestion?.CountryId,
                                        AirportLocationId: suggestion?.AirportLocationId
                                    }))}
                                    onSelect={(value, option) => {
                                        handleSuggestionClick('AirportFromLocationName',
                                            option?.City,
                                            option.AirportLocationId,
                                            option?.CityCode,
                                            option?.CountryId,
                                            index
                                        )
                                    }}
                                    value={el?.AirportFromLocationName || ''}
                                    onChange={(e) => handleChange('AirportFromLocationName', e, index)}
                                    autoComplete="off"
                                    variant="borderless"
                                    className='w-100 h-auto'
                                    rootClassName='custom-autocomplete-dropdown'
                                >
                                    <div className="form-floating">
                                        <input type="text"
                                            className="form-control"
                                            id="from"
                                            placeholder="From"
                                            autoComplete='off'
                                            name='AirportFromLocationName'
                                            value={el?.AirportFromLocationName}
                                        />
                                        <label htmlFor="from">From</label>
                                        {formError?.[`AirportFromLocationName${index}`] && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.[`AirportFromLocationName${index}`]}</small>}
                                    </div>
                                </AutoComplete>
                                <button className="destinationSwipIcon" type='button' onClick={() => Swapping(index)} disabled={form?.FromId === 0 && form?.ToId === 0}>
                                    <i className={`fa-solid fa-arrow-right-arrow-left ${(swapping && swappingIndex === index) ? 'rotate_180' : ''}`}></i>
                                </button>
                            </div>
                            <div className={`${form?.JourneyType?.TripTypeId === 3 ? 'col-xl-4 col-lg-4' : 'col-xl-3 col-lg-6'} col-md-6 newautocomplete`}>
                                <AutoComplete
                                    options={data?.cityList?.filter(suggestion => (
                                        suggestion?.City?.toLowerCase()?.includes(el?.AirportToLocationName?.toLowerCase()) ||
                                        suggestion?.AirportCode?.toLowerCase()?.includes(el?.AirportToLocationName?.toLowerCase()) ||
                                        suggestion?.AirportName?.toLowerCase()?.includes(el?.AirportToLocationName?.toLowerCase()))
                                        && (multicitycollection?.[index]?.FromId > 0 ? suggestion?.AirportLocationId !== multicitycollection?.[index]?.FromId : true))?.map((suggestion, sugIndex) => ({
                                            key: sugIndex,
                                            label: (
                                                <div key={index} className='border-0 text-start'>
                                                    <span>{suggestion?.City}</span>
                                                    <br />
                                                    <small className='text-muted text-wrap'>{suggestion?.AirportName} {`(${suggestion?.AirportCode})`}</small>
                                                </div>
                                            ),
                                            value: suggestion?.AirportName,
                                            AirportCode: suggestion?.AirportCode,
                                            City: suggestion?.City,
                                            CityCode: suggestion?.CityCode,
                                            CountryId: suggestion?.CountryId,
                                            AirportLocationId: suggestion?.AirportLocationId
                                        }))}
                                    onSelect={(value, option) => {
                                        handleSuggestionClick('AirportToLocationName',
                                            option?.City,
                                            option.AirportLocationId,
                                            option?.CityCode,
                                            option?.CountryId,
                                            index
                                        )
                                    }}
                                    value={el?.AirportToLocationName || ''}
                                    onChange={(e) => handleChange('AirportToLocationName', e, index)}
                                    autoComplete="off"
                                    variant="borderless"
                                    className='w-100 h-auto'
                                    rootClassName='custom-autocomplete-dropdown'
                                >
                                    <div className="form-floating">
                                        <input type="text"
                                            className="form-control"
                                            id="to"
                                            placeholder="To"
                                            autoComplete='off'
                                            name='AirportToLocationName'
                                            value={el?.AirportToLocationName}
                                        />
                                        <label htmlFor="to">To</label>
                                        {formError?.[`AirportToLocationName${index}`] && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.[`AirportToLocationName${index}`]}</small>}
                                    </div>
                                </AutoComplete>
                            </div>

                            <div className={`${form?.JourneyType?.TripTypeId === 3 ? 'col-xl-4 col-lg-4 col-md-12' : 'col-xl-3 col-lg-6 col-md-6'} pr`}>
                                <div className="form-floating">
                                    <input type="date"
                                        className="form-control"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            document.getElementById(`departure${index}`)?.showPicker();
                                        }}
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                            document.getElementById(`departure${index}`)?.showPicker();
                                        }}
                                        min={formatDate(new Date())}
                                        // max={form?.Return ? formatDate(form?.Return) : null}
                                        name='Departure'
                                        onChange={(e) => hendledate('Departure', e.target?.value, index)}
                                        value={formatDate(el?.Departure)}
                                        id={`departure${index}`}
                                        placeholder="Departure" />
                                    {formError?.[`Departure${index}`] && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.[`Departure${index}`]}</small>}
                                    <label htmlFor="departure">Departure</label>
                                </div>
                            </div>
                            {multicitycollection?.length === 1 && <button type="button" className="btn modify" disabled={multicitycollection?.length > 4 ? true : false} onClick={() => AddCity()}>Add City</button>}
                            <button type="button" className="btn searchBtn" onClick={() => OnExplore()}>Explore</button>
                        </div>) : null
                ))
            }
            <div id="modify-multicity-div" className='modify-multicity-div show'>
                {multicitycollection?.map((el, index) => (
                    index > 0 ?
                        <div key={index} className="mainFilter modifyMultiFil row g-2">
                            <div className={`${form?.JourneyType?.TripTypeId === 3 ? 'col-xl-4 col-lg-4' : 'col-xl-3 col-lg-6'} col-md-6 pr newautocomplete`}>
                                <AutoComplete
                                    options={data?.cityList?.filter(suggestion =>
                                        (
                                            suggestion?.City?.toLowerCase()?.includes(el?.AirportFromLocationName?.toLowerCase()) ||
                                            suggestion?.AirportCode?.toLowerCase()?.includes(el?.AirportFromLocationName?.toLowerCase()) ||
                                            suggestion?.AirportName?.toLowerCase()?.includes(el?.AirportFromLocationName?.toLowerCase())
                                        )
                                        && (multicitycollection?.[index]?.ToId > 0 ? suggestion?.AirportLocationId !== multicitycollection?.[index]?.ToId : true)
                                    )?.map((suggestion, sugIndex) => ({
                                        key: sugIndex,
                                        label: (
                                            <div key={index} className='border-0 text-start'>
                                                <span>{suggestion?.City}</span>
                                                <br />
                                                <small className='text-muted text-wrap'>{suggestion?.AirportName} {`(${suggestion?.AirportCode})`}</small>
                                            </div>
                                        ),
                                        value: suggestion?.AirportName,
                                        AirportCode: suggestion?.AirportCode,
                                        City: suggestion?.City,
                                        CityCode: suggestion?.CityCode,
                                        CountryId: suggestion?.CountryId,
                                        AirportLocationId: suggestion?.AirportLocationId
                                    }))}
                                    onSelect={(value, option) => {
                                        handleSuggestionClick('AirportFromLocationName',
                                            option?.City,
                                            option.AirportLocationId,
                                            option?.CityCode,
                                            option?.CountryId,
                                            index
                                        )
                                    }}
                                    value={el?.AirportFromLocationName || ''}
                                    onChange={(e) => handleChange('AirportFromLocationName', e, index)}
                                    autoComplete="off"
                                    variant="borderless"
                                    className='w-100 h-auto'
                                    rootClassName='custom-autocomplete-dropdown'
                                >
                                    <div className="form-floating">
                                        <input type="text"
                                            className="form-control"
                                            id="from"
                                            placeholder="From"
                                            autoComplete='off'
                                            name='AirportFromLocationName'
                                            value={el?.AirportFromLocationName}
                                        />
                                        <label htmlFor="from">From</label>
                                        {formError?.[`AirportFromLocationName${index}`] && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.[`AirportFromLocationName${index}`]}</small>}
                                    </div>
                                </AutoComplete>
                                <button className="destinationSwipIcon" type='button' onClick={() => Swapping(index)} disabled={form?.FromId === 0 && form?.ToId === 0}>
                                    <i className={`fa-solid fa-arrow-right-arrow-left ${(swapping && swappingIndex === index) ? 'rotate_180' : ''}`}></i>
                                </button>
                            </div>
                            <div className={`${form?.JourneyType?.TripTypeId === 3 ? 'col-xl-4 col-lg-4' : 'col-xl-3 col-lg-6'} col-md-6 newautocomplete`}>
                                <AutoComplete
                                    options={data?.cityList?.filter(suggestion => (
                                        suggestion?.City?.toLowerCase()?.includes(el?.AirportToLocationName?.toLowerCase()) ||
                                        suggestion?.AirportCode?.toLowerCase()?.includes(el?.AirportToLocationName?.toLowerCase()) ||
                                        suggestion?.AirportName?.toLowerCase()?.includes(el?.AirportToLocationName?.toLowerCase()))
                                        && (multicitycollection?.[index]?.FromId > 0 ? suggestion?.AirportLocationId !== multicitycollection?.[index]?.FromId : true))?.map((suggestion, sugIndex) => ({
                                            key: sugIndex,
                                            label: (
                                                <div key={index} className='border-0 text-start'>
                                                    <span>{suggestion?.City}</span>
                                                    <br />
                                                    <small className='text-muted text-wrap'>{suggestion?.AirportName} {`(${suggestion?.AirportCode})`}</small>
                                                </div>
                                            ),
                                            value: suggestion?.AirportName,
                                            AirportCode: suggestion?.AirportCode,
                                            City: suggestion?.City,
                                            CityCode: suggestion?.CityCode,
                                            CountryId: suggestion?.CountryId,
                                            AirportLocationId: suggestion?.AirportLocationId
                                        }))}
                                    onSelect={(value, option) => {
                                        handleSuggestionClick('AirportToLocationName',
                                            option?.City,
                                            option.AirportLocationId,
                                            option?.CityCode,
                                            option?.CountryId,
                                            index
                                        )
                                    }}
                                    value={el?.AirportToLocationName || ''}
                                    onChange={(e) => handleChange('AirportToLocationName', e, index)}
                                    autoComplete="off"
                                    variant="borderless"
                                    className='w-100 h-auto'
                                    rootClassName='custom-autocomplete-dropdown'
                                >
                                    <div className="form-floating">
                                        <input type="text"
                                            className="form-control"
                                            id="to"
                                            placeholder="To"
                                            autoComplete='off'
                                            name='AirportToLocationName'
                                            value={el?.AirportToLocationName}
                                        />
                                        <label htmlFor="to">To</label>
                                        {formError?.[`AirportToLocationName${index}`] && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.[`AirportToLocationName${index}`]}</small>}
                                    </div>
                                </AutoComplete>
                            </div>
                            <div className={`${form?.JourneyType?.TripTypeId === 3 ? 'col-xl-4 col-lg-4 col-md-12' : 'col-xl-3 col-lg-6 col-md-6'} pr`}>
                                <div className="form-floating">
                                    <input type="date"
                                        className="form-control"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            document?.getElementById(`departure${index}`)?.showPicker();
                                        }}
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                            document?.getElementById(`departure${index}`)?.showPicker();
                                        }}
                                        min={formatDate(new Date(multicitycollection?.[index - 1]?.Departure))}
                                        // max={form?.Return ? formatDate(form?.Return) : null}
                                        name='Departure'
                                        onChange={(e) => hendledate('Departure', e?.target?.value, index)}
                                        value={el?.Departure ? formatDate(el?.Departure) : ''}
                                        id={`departure${index}`}
                                        placeholder="Departure" />
                                    {formError?.[`Departure${index}`] && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.[`Departure${index}`]}</small>}
                                    <label htmlFor="departure">Departure</label>
                                </div>
                            </div>
                            {multicitycollection.length - 1 === index && <button type="button" className="btn addCity" disabled={multicitycollection?.length > 4 ? true : false} onClick={() => AddCity()}>Add City</button>}
                            {index > 1 && <i className="fa-solid fa-xmark removeCity" onClick={() => removecity(index)}></i>}
                        </div> : null
                )
                )}
            </div>

        </form >
    )
}

export default FilterFormFlight